import 'selectric';

$('.js-select').selectric({
    disableOnMobile: false,
    nativeOnMobile: false
});
